webpackJsonp([40078938568781],{

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp-tablet":"(max-width: 1200px)","sectionWrapper":"src-layouts----app-module---sectionWrapper---33Nem"};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _appModule = __webpack_require__(9);
	
	var _appModule2 = _interopRequireDefault(_appModule);
	
	var _legalMentionsModule = __webpack_require__(257);
	
	var _legalMentionsModule2 = _interopRequireDefault(_legalMentionsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LegalMentions = function (_React$Component) {
	  _inherits(LegalMentions, _React$Component);
	
	  function LegalMentions() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LegalMentions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      email: '',
	      phone: '',
	      laurenceEmail: '',
	      teamUXemail: '',
	      developerEmail: ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LegalMentions.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      email: 'contact@lasantedigitale.fr',
	      phone: '+ 33 (0)6 12 73 35 56',
	      laurenceEmail: 'laurence.dardenne@lasantedigitale.fr',
	      teamUXemail: 'hello@team-ux.com',
	      developerEmail: 'dev.vialajulien@gmail.com'
	    });
	  };
	
	  LegalMentions.prototype.render = function render() {
	    var _state = this.state,
	        email = _state.email,
	        phone = _state.phone,
	        laurenceEmail = _state.laurenceEmail,
	        teamUXemail = _state.teamUXemail,
	        developerEmail = _state.developerEmail;
	
	
	    var rootElementCSSClassnames = (0, _classnames2.default)(_legalMentionsModule2.default.legalMentions, _appModule2.default.sectionWrapper);
	
	    return _react2.default.createElement(
	      'div',
	      { className: rootElementCSSClassnames },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Mentions l\xE9gales'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Editeur du site'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'LA SANT\xC9 DIGITALE'
	        ),
	        _react2.default.createElement(
	          'address',
	          null,
	          '3 rue Delandre ',
	          _react2.default.createElement('br', null),
	          '33200 Bordeaux ',
	          _react2.default.createElement('br', null),
	          'France'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'T\xE9l. :\xA0',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'tel: ' + phone.replace('(0)', '').replace(/ /g, '')
	            },
	            phone
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'LA SANT\xC9 DIGITALE est une SARLU au capital de 2450\u20AC - 812 160 752 R.C.S. Bordeaux - APE : 8299Z'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Conditions d\'utilisation'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Le site accessible par l\'url suivante :',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'www.lasantedigitale.fr'
	          ),
	          ' ',
	          'est exploit\xE9 dans le respect de la l\xE9gislation fran\xE7aise. L\'utilisation de ce site est r\xE9gie par les pr\xE9sentes conditions g\xE9n\xE9rales. En utilisant le site, vous reconnaissez avoir pris connaissance de ces conditions et les avoir accept\xE9es. Celles-ci pourront \xEAtre modifi\xE9es \xE0 tout moment et sans pr\xE9avis par la soci\xE9t\xE9 LA SANT\xC9 DIGITALE. ',
	          _react2.default.createElement('br', null),
	          ' \u2028LA SANT\xC9 DIGITALE ne saurait \xEAtre tenu pour responsable en aucune mani\xE8re d\'une mauvaise utilisation du service.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Responsable \xE9ditorial'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Laurence DARDENNE',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'strong',
	          null,
	          '\u2028LA SANT\xC9 DIGITALE\u2028'
	        ),
	        _react2.default.createElement(
	          'address',
	          null,
	          '3 rue Delandre ',
	          _react2.default.createElement('br', null),
	          '33200 Bordeaux ',
	          _react2.default.createElement('br', null),
	          'France'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'T\xE9l. :\xA0',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'tel: ' + phone.replace('(0)', '').replace(/ /g, '')
	            },
	            phone
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Limitation de responsabilit\xE9'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Les informations contenues sur ce site sont aussi pr\xE9cises que possibles et le site est p\xE9riodiquement remis \xE0 jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes. Si vous constatez une lacune, erreur ou ce qui parait \xEAtre un dysfonctionnement, merci de bien vouloir le signaler par email (',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'mailto:' + email
	            },
	            email
	          ),
	          ') en d\xE9crivant le probl\xE8me de la mani\xE8re la plus pr\xE9cise possible.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Tout contenu t\xE9l\xE9charg\xE9 se fait aux risques et p\xE9rils de l\'utilisateur et sous sa seule responsabilit\xE9. En cons\xE9quence,',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          ),
	          ' ',
	          'ne saurait \xEAtre tenu responsable d\'un quelconque dommage subi par l\'ordinateur de l\'utilisateur ou d\'une quelconque perte de donn\xE9es cons\xE9cutives au t\xE9l\xE9chargement. ',
	          _react2.default.createElement('br', null),
	          'Les visuels sont non contractuels. ',
	          _react2.default.createElement('br', null),
	          'Les liens hypertextes mis en place dans le cadre du pr\xE9sent site internet en direction d\'autres ressources pr\xE9sentes sur le r\xE9seau Internet ne sauraient engager la responsabilit\xE9 de',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Droit d\'acc\xE8s'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'En application de cette loi, les internautes disposent d\'un droit d\'acc\xE8s, de rectification, de modification et de suppression concernant les donn\xE9es qui les concernent personnellement. Ce droit peut \xEAtre exerc\xE9 par voie postale aupr\xE8s de :'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'strong',
	          null,
	          'LA SANT\xC9 DIGITALE'
	        ),
	        _react2.default.createElement(
	          'address',
	          null,
	          '3 rue Delandre ',
	          _react2.default.createElement('br', null),
	          '33200 Bordeaux ',
	          _react2.default.createElement('br', null),
	          'France',
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement('br', null),
	        'ou par courrier \xE9lectronique \xE0 :\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + email },
	          email
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          '\u2028Les informations personnelles collect\xE9es ne sont en aucun cas confi\xE9es \xE0 des tiers hormis pour l\'\xE9ventuelle bonne ex\xE9cution de la prestation command\xE9e par l\'internaute.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Confidentialit\xE9'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Vos donn\xE9es personnelles sont confidentielles et ne seront en aucun cas communiqu\xE9es \xE0 des tiers hormis pour la bonne ex\xE9cution de la prestation.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Propri\xE9t\xE9 intellectuelle'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Tout le contenu du pr\xE9sent site, incluant, de fa\xE7on non limitative, les graphismes, images, textes, vid\xE9os, animations, sons, logos, gifs et ic\xF4nes ainsi que leur mise en forme sont la propri\xE9t\xE9 exclusive de la soci\xE9t\xE9 LA SANT\xC9 DIGITALE \xE0 l\'exception des marques, logos ou contenus appartenant \xE0 d\'autres soci\xE9t\xE9s partenaires ou auteurs.\u2028Toute reproduction, distribution, modification, adaptation, retransmission ou publication, m\xEAme partielle, de ces diff\xE9rents \xE9l\xE9ments est strictement interdite sans l\'accord expr\xE8s par \xE9crit de LA SANT\xC9 DIGITALE. Cette repr\xE9sentation ou reproduction, par quelque proc\xE9d\xE9 que ce soit, constitue une contrefa\xE7on sanctionn\xE9e par les articles L.3335-2 et suivants du Code de la propri\xE9t\xE9 intellectuelle. Le non-respect de cette interdiction constitue une contrefa\xE7on pouvant engager la responsabilit\xE9 civile et p\xE9nale du contrefacteur. En outre, les propri\xE9taires des Contenus copi\xE9s pourraient intenter une action en justice \xE0 votre encontre.',
	          _react2.default.createElement('br', null),
	          'LA SANT\xC9 DIGITALE est identiquement propri\xE9taire des "droits des producteurs de bases de donn\xE9es" vis\xE9s au Livre III, Titre IV, du Code de la Propri\xE9t\xE9 Intellectuelle (loi n\xB0 98-536 du 1er juillet 1998) relative aux droits d\'auteur et aux bases de donn\xE9es.',
	          _react2.default.createElement('br', null),
	          '\xA0Les utilisateurs et visiteurs du site internet peuvent mettre en place un hyperlien en direction de ce site, mais uniquement en direction de la page d\'accueil, accessible \xE0 l\'URL suivante :',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'www.lasantedigitale.fr'
	          ),
	          ', \xE0 condition que ce lien s\'ouvre dans une nouvelle fen\xEAtre. En particulier un lien vers une sous page (\xAB lien profond \xBB) est interdit, ainsi que l\'ouverture du pr\xE9sent site au sein d\'un cadre (\xAB framing \xBB), sauf l\'autorisation expresse et pr\xE9alable de LA SANT\xC9 DIGITALE.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Pour toute demande d\'autorisation ou d\'information, veuillez nous contacter par email :\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:' + email },
	            email
	          ),
	          '.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Cr\xE9\xE9 le : 18/07/2018'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Auteur\xA0: Laurence Dardenne'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'E-mail de l\'auteur :',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:' + laurenceEmail },
	              laurenceEmail
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Cr\xE9dits'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Conception UX et graphisme'
	          ),
	          ' :',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:' + teamUXemail },
	            'Yuna Orsini et Daniela Pe\xF1eranda'
	          ),
	          '.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'D\xE9veloppement'
	          ),
	          ' :',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:' + developerEmail },
	            'Julien Viala'
	          ),
	          '.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Service d\'h\xE9bergement de site web :'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://yulpa.io/', target: '_blank' },
	            'Yulpa'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Conditions de service'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Ce site est propos\xE9 en langages\xA0HTML5,\xA0CSS3 et JavaScript, pour un meilleur confort d\'utilisation et un graphisme plus agr\xE9able, nous vous recommandons de recourir \xE0 des navigateurs modernes comme Safari, Firefox, Chrome...'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Informations et exclusion'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          ),
	          ' ',
	          'met en \u0153uvre tous les moyens dont elle dispose, pour assurer une information fiable et une mise \xE0 jour fiable de ses sites internet. Toutefois, des erreurs ou omissions peuvent survenir. L\'internaute devra donc s\'assurer de l\'exactitude des informations aupr\xE8s de LA SANT\xC9 DIGITALE, et signaler toutes modifications du site qu\'il jugerait utile. LA SANT\xC9 DIGITALE n\'est en aucun cas responsable de l\'utilisation faite de ces informations, et de tout pr\xE9judice direct ou indirect pouvant en d\xE9couler.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Cookies'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Pour des besoins de statistiques et d\'affichage, le pr\xE9sent site utilise des cookies. Il s\'agit de petits fichiers textes stock\xE9s sur votre disque dur afin d\'enregistrer des donn\xE9es techniques sur votre navigation. Certaines parties de ce site ne peuvent \xEAtre fonctionnelle sans l\'acceptation de cookies.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Liens hypertextes'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Les sites internet de',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          ),
	          ' ',
	          'peuvent offrir des liens vers d\'autres sites internet ou d\'autres ressources disponibles sur Internet.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          ),
	          ' ',
	          'ne dispose d\'aucun moyen pour contr\xF4ler les sites en connexion avec ses sites internet. lasantedigitale.fr ne r\xE9pond pas de la disponibilit\xE9 de tels sites et sources externes, ni ne la garantit. Elle ne peut \xEAtre tenue pour responsable de tout dommage, de quelque nature que ce soit, r\xE9sultant du contenu de ces sites ou sources externes, et notamment des informations, produits ou services qu\'ils proposent, ou de tout usage qui peut \xEAtre fait de ces \xE9l\xE9ments. Les risques li\xE9s \xE0 cette utilisation incombent pleinement \xE0 l\'internaute, qui doit se conformer \xE0 leurs conditions d\'utilisation...'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Recherche'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'En outre, le renvoi sur un site internet pour compl\xE9ter une information recherch\xE9e ne signifie en aucune fa\xE7on que LA SANT\xC9 DIGITALE reconna\xEEt ou accepte quelque responsabilit\xE9 quant \xE0 la teneur ou \xE0 l\'utilisation dudit site.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Pr\xE9cautions d\'usage'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Il vous incombe par cons\xE9quent de prendre les pr\xE9cautions d\'usage n\xE9cessaires pour vous assurer que ce que vous choisissez d\'utiliser ne soit pas entach\xE9 d\'erreurs voire d\'\xE9l\xE9ments de nature destructrice tels que virus, trojans, etc...'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Responsabilit\xE9'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Aucune autre garantie n\'est accord\xE9e au client, auquel incombe l\'obligation de formuler clairement ses besoins et le devoir de s\'informer. Si des informations fournies par',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.lasantedigitale.fr' },
	            'https://www.lasantedigitale.fr'
	          ),
	          ' ',
	          'apparaissent inexactes, il appartiendra au client de proc\xE9der lui-m\xEAme \xE0 toutes v\xE9rifications de la coh\xE9rence ou de la vraisemblance des r\xE9sultats obtenus. lasantedigitale.fr ne sera en aucune fa\xE7on responsable vis \xE0 vis des tiers de l\'utilisation par le client des informations ou de leur absence contenues dans ses produits y compris un de ses sites Internet.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Contactez-nous'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'LA SANT\xC9 DIGITALE est \xE0 votre disposition pour tous vos commentaires ou suggestions.',
	          _react2.default.createElement('br', null),
	          'Vous pouvez nous \xE9crire par courrier \xE9lectronique \xE0 :\xA0',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'mailto:' + email
	            },
	            email
	          )
	        )
	      )
	    );
	  };
	
	  return LegalMentions;
	}(_react2.default.Component);
	
	exports.default = LegalMentions;
	module.exports = exports['default'];

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp-tablet":"(max-width: 1200px)","legalMentions":"src-pages----legal-mentions-module---legalMentions---1SSLN"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legal-mentions-js-fe7ea46c72bc7da88f4b.js